import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Input,
  Icon,
  Avatar,
  Divider,
  Popconfirm
} from 'antd'

import { useDeepEffect } from '../../../utils/hooks'
import _ from 'lodash'
import PresetCategoryForm from './components/PresetCategoryForm'
import axios from 'axios'
import Highlighter from 'react-highlight-words'

const PresetCategory = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [presetCategory, setPresetCategory] = useState([])
  const [searchText, setSearchText] = useState('')
  let searchInput = useRef(null)

  async function fetchPresetCategory() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/preset/category`
      )
      setPresetCategory(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function updatePresetCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/preset/updateCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function createPresetCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/preset/createCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function deletePresetCategory(id) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.delete(
        process.env.REACT_APP_API_ENDPOINT + `/preset/category/` + id, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchPresetCategory()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await fetchPresetCategory()
    await setVisible(false)
  }

  const refetchData = async () => { }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await updatePresetCategory(data)
    } else {
      await createPresetCategory(data)
    }
    await fetchPresetCategory()
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await deletePresetCategory(id)
    await fetchPresetCategory()
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'position',
      key: 'position',
      width: 100,
    },
    {
      title: 'Preset Category',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name')
    },
    {
      title: 'English name',
      dataIndex: 'engName',
      key: 'engName',
      ...getColumnSearchProps('engName')
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Preset Category"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Preset Category
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }
    >
      <Table
        rowKey={(record) => record.id}
        dataSource={presetCategory}
        columns={columns}
      />
      <PresetCategoryForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(PresetCategory)